import classNames from 'classnames'
import type { FocusEvent } from 'react'
import { Radio } from 'src/modules/core/components/radio'
import { Typography } from 'src/modules/core/components/typography'
import type { RadioGroupProps } from './radio-group.interface'
import classes from './radio-group.module.scss'

export function RadioGroup({
  id,
  legend,
  options,
  value,
  onChange,
  onBlur,
  error,
  errorId = `${id}-error`,
  required,
  className,
}: RadioGroupProps) {
  const handleBlur = (event: FocusEvent<HTMLFieldSetElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget as Node | null)) onBlur?.()
  }

  return (
    <fieldset id={id} className={classNames(classes.root, className)} onBlur={handleBlur}>
      <legend className={classes.legend}>
        <Typography
          variant="body"
          element="span"
          className={classNames(classes.legendText, { [classes.legendError]: !!error })}
        >
          {legend}
        </Typography>
      </legend>
      <div className={classes.options}>
        {options.map((option, index) => {
          const optionId = `${id}-option-${index}`
          return (
            <div key={option.value} className={classes.option}>
              <Radio
                id={optionId}
                name={id}
                value={option.value}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
                required={required}
                aria-invalid={error ? true : undefined}
                aria-describedby={error ? errorId : undefined}
              />
              <label htmlFor={optionId} className={classes.optionLabel}>
                {option.label}
              </label>
            </div>
          )
        })}
      </div>
      {error && (
        <Typography id={errorId} className={classes.error} variant="body">
          {error}
        </Typography>
      )}
    </fieldset>
  )
}
